const trap = function(el, binding, vnode){

    // Initialize event handler
    let trapHandler

    if(binding.value){

        // Usage
        // Place v-trap directive on parent to trap focus to only its children
        // If "isActive" is true, will trap focus
        // <div v-trap="isActive" class="someElement">
        //     <button>Some button</button>
        //     <a href="#">Some link</a>
        // </div>

        // Inspired by https://uxdesign.cc/how-to-trap-focus-inside-modal-to-make-it-ada-compliant-6a50f9a70700

        // add all the elements inside parent which you want to make focusable
        const  focusableElements =
        'button, [href], input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])';

        // el is element with v-trap directive on it
        const firstFocusableElement = el.querySelectorAll(focusableElements)[0]; // get first element to be focused inside el
        const focusableContent = el.querySelectorAll(focusableElements);
        const lastFocusableElement = focusableContent[focusableContent.length - 1]; // get last element to be focused inside el

        trapHandler = function(e) {
            let isTabPressed = e.key === 'Tab' || e.keyCode === 9;

            let isEscPressed = e.key === 'Escape'

            // If escape key, remove listener, remove focus, and emit a close event
            if(isEscPressed){
                document.removeEventListener('keydown', trapHandler );
                document.activeElement.blur()
                vnode.context.$emit('close') // Could be a value passed if we want to make it any emit type
            }

            // If any key except tab is pressed, ignore
            else if (!isTabPressed) {
                return;
            }

            if (e.shiftKey) { // if shift key pressed for shift + tab combination
                if (document.activeElement === firstFocusableElement) {
                    // console.log("first one")
                    lastFocusableElement.focus(); // add focus for the last focusable element
                    e.preventDefault();
                }
            } else { // if tab key is pressed
                //console.log(document.activeElement)
                if (document.activeElement === lastFocusableElement) { // if focused has reached to last focusable element then focus first focusable element after pressing tab
                    // console.log("last one")

                    firstFocusableElement.focus(); // add focus for the first focusable element
                    e.preventDefault();
                }
            }
        }


        document.addEventListener('keydown', trapHandler );
        firstFocusableElement.focus();
        // console.log("Adding listener")
    }

    else {
        document.removeEventListener('keydown', trapHandler );
        // console.log("Removing listening")
    }
}

export default trap